function About() {
  return (
    <section className="section about" id="about">
      <div className="section-heading">
        <span>About us</span>
        <h2>Made with care, one piece at a time.</h2>
      </div>

      <div className="about-content">
        <p>
          Charmie’s Kastle is not a place — it’s a mind.
          <br />
          <br />
          Charmie creates tiny treasures from her thoughts — little charms,
          creatures, combs, clips, and objects that feel like they came from a
          dream you almost remember. Every piece you receive is more than
          something to wear, hold, or collect.
          <br />
          <br />
          It is a small fragment of Charmie’s world.
        </p>

        <p>
          We create small items for everyday use, gifts, custom ideas, and
          special details that make simple things feel more unique.
        </p>
      </div>
    </section>
  );
}

export default About;